import React, { useEffect } from "react";
import { Link } from "react-router-dom";

const FullStackDevelopment = () => {
  useEffect(() => {
    // Scroll to the banner section on page load
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <section className="banner">
        <div className="banner-overlay"></div>
        <div className="banner-content">
          <h6 className="banner-subtitle">
            Home / Training / Full Stack Development
          </h6>
          <hr />
          <h1 className="banner-title">Full-Stack Development Bootcamp</h1>
          <p>
            Become a Full-Stack Web Developer. HTML, CSS, Javascript, Vue.js,
            React, MySQL, PostgreSQL
          </p>
        </div>
        <img
          src="https://img.freepik.com/free-photo/front-view-programmer-working-all-night-long_1098-18697.jpg?w=900&t=st=1732024113~exp=1732024713~hmac=bf20401ed252a747b2d871d7b1e0c9e9b8d4e03be8fa020d251f74947382c73d"
          alt="Banner Background"
          className="banner-image"
        />
      </section>

      <section id="about_pg" className="p_3">
        <div className="container-xl">
          <div className="row about_pg1">
            <div className="col-md-12">
              <div className="about_pg1l mt-5">
                <h6 className="col_yell text-center">Full-Stack Development</h6>
                <h2 className="mt-3 mb-3 text-center">
                  Become a Full-Stack Developer and Build Dynamic Applications
                </h2>
                <p className="text-center">
                  Master the skills to create robust and scalable applications.
                  Our Full-Stack Development Bootcamp covers everything from
                  front-end design to back-end architecture, empowering you to
                  build modern web solutions that drive success in the
                  tech-driven world.
                </p>
              </div>
            </div>
            {/* <div className="col-md-6">
        <div className="about_pg1r">
          <div className="grid clearfix">
            <figure className="effect-jazz mb-0">
              <a href="#">
                <img
                  src="https://img.freepik.com/free-photo/front-view-programmer-working-all-night-long_1098-18697.jpg?w=900&t=st=1732024113~exp=1732024713~hmac=bf20401ed252a747b2d871d7b1e0c9e9b8d4e03be8fa020d251f74947382c73d"
                  className="w-100"
                  alt="Full-Stack Development Bootcamp"
                />
              </a>
            </figure>
          </div>
        </div>
      </div> */}
          </div>
        </div>
      </section>

      <hr />
      <section id="course-content">
        <div class="container-xl mt-5">
          <h2 class="mb-2">Course content</h2>
          <p class="mb-4">
            A comprehensive roadmap to becoming a Full-Stack Developer
          </p>

          <div class="accordion" id="courseAccordion">
            <div class="accordion-item">
              <h2 class="accordion-header" id="headingOne">
                <button
                  class="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseOne"
                  aria-expanded="true"
                  aria-controls="collapseOne"
                >
                  1. Introduction to Web Development
                </button>
              </h2>
              <div
                id="collapseOne"
                class="accordion-collapse collapse show"
                aria-labelledby="headingOne"
                data-bs-parent="#courseAccordion"
              >
                <div class="accordion-body">
                  <ul>
                    <li>Overview of Full-Stack Development</li>
                    <li>How the Web Works (Frontend, Backend, Database)</li>
                    <li>
                      Tools and Environment Setup (VSCode, Git, Node.js, etc.)
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="accordion-item">
              <h2 class="accordion-header" id="headingTwo">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseTwo"
                  aria-expanded="false"
                  aria-controls="collapseTwo"
                >
                  2. HTML & CSS Fundamentals
                </button>
              </h2>
              <div
                id="collapseTwo"
                class="accordion-collapse collapse"
                aria-labelledby="headingTwo"
                data-bs-parent="#courseAccordion"
              >
                <div class="accordion-body">
                  <ul>
                    <li>HTML5 Basics</li>
                    <li>Semantic HTML</li>
                    <li>CSS3 Basics</li>
                    <li>Responsive Design with Flexbox and Grid</li>
                    <li>CSS Frameworks: Bootstrap/Tailwind</li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="accordion-item">
              <h2 class="accordion-header" id="headingThree">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseThree"
                  aria-expanded="false"
                  aria-controls="collapseThree"
                >
                  3. JavaScript Basics
                </button>
              </h2>
              <div
                id="collapseThree"
                class="accordion-collapse collapse"
                aria-labelledby="headingThree"
                data-bs-parent="#courseAccordion"
              >
                <div class="accordion-body">
                  <ul>
                    <li>Variables, Data Types, and Operators</li>
                    <li>Functions and Scopes</li>
                    <li>DOM Manipulation</li>
                    <li>Events and Event Listeners</li>
                    <li>
                      ES6+ Features (Arrow Functions, Destructuring, Modules)
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="accordion-item">
              <h2 class="accordion-header" id="headingFour">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFour"
                  aria-expanded="false"
                  aria-controls="collapseFour"
                >
                  4. Advanced JavaScript & Frontend Development
                </button>
              </h2>
              <div
                id="collapseFour"
                class="accordion-collapse collapse"
                aria-labelledby="headingFour"
                data-bs-parent="#courseAccordion"
              >
                <div class="accordion-body">
                  <ul>
                    <li>Asynchronous JavaScript (Promises, Async/Await)</li>
                    <li>API Calls (Fetch, Axios)</li>
                    <li>
                      Introduction to Frontend Frameworks (React or Vue.js)
                    </li>
                    <li>Component-Based Architecture</li>
                    <li>State Management (Redux or Vuex)</li>
                    <li>SPA (Single Page Application) Development</li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="accordion-item">
              <h2 class="accordion-header" id="headingFive">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseFive"
                  aria-expanded="false"
                  aria-controls="collapseFive"
                >
                  5. Backend Development (Django & Laravel)
                </button>
              </h2>
              <div
                id="collapseFive"
                class="accordion-collapse collapse"
                aria-labelledby="headingFive"
                data-bs-parent="#courseAccordion"
              >
                <div class="accordion-body">
                  <ul>
                    <li>
                      <strong>Django:</strong>
                    </li>
                    <ul>
                      <li>Setting up Django Environment</li>
                      <li>Understanding Django MVC Architecture</li>
                      <li>Building RESTful APIs with Django Rest Framework</li>
                      <li>Django Authentication and Permissions</li>
                      <li>Working with Django ORM</li>
                    </ul>
                    <li>
                      <strong>Laravel:</strong>
                    </li>
                    <ul>
                      <li>Setting up Laravel Environment</li>
                      <li>Understanding Laravel MVC Architecture</li>
                      <li>Building RESTful APIs with Laravel</li>
                      <li>Laravel Authentication (Sanctum/Passport)</li>
                      <li>Eloquent ORM Basics</li>
                    </ul>
                  </ul>
                </div>
              </div>
            </div>

            <div class="accordion-item">
              <h2 class="accordion-header" id="headingSix">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseSix"
                  aria-expanded="false"
                  aria-controls="collapseSix"
                >
                  6. Database Management
                </button>
              </h2>
              <div
                id="collapseSix"
                class="accordion-collapse collapse"
                aria-labelledby="headingSix"
                data-bs-parent="#courseAccordion"
              >
                <div class="accordion-body">
                  <ul>
                    <li>Introduction to Databases (SQL vs. NoSQL)</li>
                    <li>SQL Basics (MySQL/PostgreSQL)</li>
                    <li>MongoDB Basics</li>
                    <li>Database Design and Relationships</li>
                    <li>Connecting Database with Backend (Django & Laravel)</li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="accordion-item">
              <h2 class="accordion-header" id="headingSeven">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseSeven"
                  aria-expanded="false"
                  aria-controls="collapseSeven"
                >
                  7. Version Control with Git and GitHub
                </button>
              </h2>
              <div
                id="collapseSeven"
                class="accordion-collapse collapse"
                aria-labelledby="headingSeven"
                data-bs-parent="#courseAccordion"
              >
                <div class="accordion-body">
                  <ul>
                    <li>Git Basics</li>
                    <li>Repository Management</li>
                    <li>Branching and Merging</li>
                    <li>Collaboration on GitHub</li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="accordion-item">
              <h2 class="accordion-header" id="headingEight">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseEight"
                  aria-expanded="false"
                  aria-controls="collapseEight"
                >
                  8. Deployment and DevOps Basics
                </button>
              </h2>
              <div
                id="collapseEight"
                class="accordion-collapse collapse"
                aria-labelledby="headingEight"
                data-bs-parent="#courseAccordion"
              >
                <div class="accordion-body">
                  <ul>
                    <li>Hosting Websites (Netlify, Vercel)</li>
                    <li>
                      Deploying Full-Stack Applications (Heroku, AWS, Digital
                      Ocean)
                    </li>
                    <li>CI/CD Basics</li>
                    <li>Docker for Beginners</li>
                  </ul>
                </div>
              </div>
            </div>

            <div class="accordion-item">
              <h2 class="accordion-header" id="headingNine">
                <button
                  class="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#collapseNine"
                  aria-expanded="false"
                  aria-controls="collapseNine"
                >
                  9. Capstone Project
                </button>
              </h2>
              <div
                id="collapseNine"
                class="accordion-collapse collapse"
                aria-labelledby="headingNine"
                data-bs-parent="#courseAccordion"
              >
                <div class="accordion-body">
                  <p>
                    Develop a fully functional full-stack application,
                    integrating all skills learned throughout the course.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section id="serv_h" className="p_3">
        <div className="container-xl">
          <div
            className="row serv_h3 mt-4 pt-5 pb-5 mx-0 px-4"
            style={{ backgroundColor: "black", color: "white" }}
          >
            <div className="col-md-8">
              <div className="serv_h3l">
                <h6 className="">Benefits</h6>
                <h2 className="text-white">
                  Master Full-Stack Development and transform your career.
                </h2>
                <p className="text-white mt-3">
                  "Join our Full-Stack Development Bootcamp to gain hands-on
                  experience in both front-end and back-end technologies. Learn
                  to build modern web applications, work with popular frameworks
                  like React, Django, and Laravel, and prepare for real-world
                  development challenges."
                </p>
                <button className="banner-button mt-3">
                  <Link
                    to="/contact"
                    className="text-decoration-none text-white"
                  >
                    Let’s talk <span className="arrow">→</span>
                  </Link>
                </button>
              </div>
            </div>
            <div className="col-md-4">
              <div className="serv_h3r">
                <div className="grid clearfix">
                  <figure className="effect-jazz mb-0">
                    <Link to="/contact">
                      <img
                        src="https://img.freepik.com/free-photo/colleagues-working-together-office_23-2148738266.jpg"
                        className="w-100"
                        alt="Full-Stack Development Bootcamp"
                      />
                    </Link>
                  </figure>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default FullStackDevelopment;
